<div class="flex flex-col flex-auto min-w-0">
      
    <div class="flex-auto p-2 sm:p-10 flexbg-gray-100 ">
           <!-- Breadcrumbs -->
        <nav class="text-m text-gray-600 mb-4" aria-label="Breadcrumb">
            <ol class="flex items-center space-x-2 font-medium">
                <li>
                    <a routerLink="/monthly-importer-summary" class="hover:underline text-gray-600"   [queryParams]="{ startDate: originalStartDate, endDate: originalEndDate }">{{ "MONTHLY_IMPORTER.SUMMARY" | translate }}</a>
                    <span> ></span>
                </li>
                <li>
                    <a  class="hover:underline text-gray-600">Scorecard</a>
                </li>
            </ol>
        </nav>

        <div class="flex row h-screen">
            <div #sideMenu class="w-64 h-full bg-white p-3 flex-shrink-0 sticky left-0 top-0 self-start">
                <h1 class="text-2xl font-bold">{{ "MONTHLY_IMPORTER.VENDORS_SCORECARD" | translate }}</h1>
                 <div style="max-height: 300px; overflow-y: auto; margin-top:25px">
                    <table style="width: 100%;">
                        <thead>
                        <tr>
                            <th style="position: sticky; top: 0; background-color: white; z-index: 1;" class="text-xl">Vendors</th>
                        </tr>
                        </thead>
                        <tbody>
                         <!-- Spacer row -->
                        <tr>
                            <td style="height: 10px; padding: 0; border: none;"></td>
                        </tr>
                        <tr *ngFor="let element of vendorsDataSource" (click)="onImporterClick(element)" style="cursor: pointer;">
                            <td
                            [ngClass]="{ 'highlight-blue': element === importerName }"
                            style="padding: 8px; border-top: 1px solid #eee;"
                        >{{ element }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <div class="flex items-center justify-between w-full mb-2 mt-10">
                        <h2 class="text-xl font-bold">Filters</h2>
                        <button mat-icon-button (click)="clearFilter()" class="refreshButton " aria-label="Refresh">
                                <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                    <div class="form-group flex flex-wrap items-center mb-0">
                        <mat-form-field appearance="fill" class="mat-forms">
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate placeholder="Start date" [formControl]="startDateControl" />
                                <input matEndDate placeholder="End date" [formControl]="endDateControl"
                                    (dateChange)="changeEndDate($event)" />
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="mat-forms">
                            <mat-select multiple [formControl]="countryControl" placeholder="Country"
                                (openedChange)="onOpenChange(multiCountrySearch, 'Country')">
                                <input #multiCountrySearch type="text" class="ml-4 inputField" autocomplete="off" matInput
                                    placeholder="Search By Country" (input)="onInputChange($event, 'Country')" />
                                <mat-option *ngFor="let country of countryFilter" [value]="country"
                                    (onSelectionChange)="selection($event, 'Country')">
                                    {{ country }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="mat-forms">
                            <mat-icon matPrefix class="highlight-blue" style="margin:0 2px 0 4px; color: #89d1ee;font-weight: bold;">search</mat-icon>
                            <input matInput type="text" [formControl]="nameIDControl" placeholder="Search by Name/ID"  />
                        </mat-form-field>
                          <div class="w-full flex justify-center mt-2">
                            <button mat-button class="text-base" color="primary" (click)="applyFilters()">
                            <mat-icon [svgIcon]="'feather:filter'"></mat-icon>Apply filters
                            </button>
                        </div>
                    </div>

                </div>
                



            </div>

            <div #rightCard  class="flex-1 px-4 py-3 bg-white ml-2 h-full overflow-y-auto">
                <h1 class="text-2xl font-bold">Scorecard for {{ importerName }}</h1>
                <h2 class="text-xl font-bold" style="margin-top:25px">{{ "MONTHLY_IMPORTER.SUPPLIER_MAP" | translate }}</h2>
                    <div id="map-container-wrapper"> 
                        <div class="map-container-wrapper-div">
                        <loading-spinner *ngIf="isLoadingSupplierCountries"></loading-spinner>
                        <div id="map-container">
                            <ng-container *ngIf="!isLoadedMap; else loadingMapPlaceholder">
                                <!-- Actual map logic goes here, e.g. map rendering -->
                            </ng-container>

                            <ng-template #loadingMapPlaceholder>
                                <div class="pt-3 map-placeholder">
                                Loading map...
                                </div>
                            </ng-template>
                            </div>

                        <div id="tooltip" class="disable-hover"></div>
                        </div>

                        <div id="map-container-left-info" class="flex flex-col flex-grow overflow-hidden">
                          <!-- <loading-spinner *ngIf="isLoadingnrFactories"></loading-spinner> -->

                        <div class="environmental-component-container flex flex-col" [style.height.px]="mapHeight">
                            <div class="px-4">
                                <div class="text-center font-bold text-black text-m">
                                Total Number of Factories
                                </div>
                            </div>

                            <!-- Content -->
                            <div class="flex-grow flex items-center justify-center p-4">
                                    <div class="text-center">
                                        <div class="font-bold text-xl text-black">
                                        {{ connectedFactories }}
                                        </div>
                                        <div>Factories connected to you</div>
                                    </div>
                                </div>
                            </div>                           
                        </div>
                    </div>
                    <div class="product-module flex flex-row w-full">
                                <div class="w-2/5 flex flex-col environmental-component-container">
                                    <div class="flex flex-row justify-end ">
                                        <span class=" font-bold tracking-tight leading-8 flex-auto text-center">
                                            {{ "PRODUCT_MODULE.DPP_COMPONENT.CHEMICAL_COMPLIANCE" | translate }}
                                        </span>
                                    </div>
                                    <div class="mt-2 h-full environmental-component-container-canvas">
                                    <loading-spinner *ngIf="isLoadingChemicalCompliance"></loading-spinner>
                                        <div *ngIf="hasComplianceFiltered"  style="height: 87%">
                                            <canvas baseChart height="300" width="150" [datasets]="chemicalsChartDataFiltered"
                                                [labels]="chemicalsChartLabelsFiltered" [options]="chartOptions"
                                                [legend]="chartLegend" type="bar" style="margin-left: 2vw; z-index: 1" #myChart>
                                            </canvas>
                                            <div class="product-module-legend-container">
                                                <div>
                                                    <div
                                                        style="background-color: #EC8484; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                                    </div>
                                                    <span style="font-size:11px;">&lt;60% compliance</span>
                                                </div>
                                                <div>
                                                    <div
                                                        style="background-color: #FFD073; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                                    </div>
                                                    <span style="font-size:11px;">60-80% compliance</span>
                                                </div>
                                                <div>
                                                    <div
                                                       
                                                        style="background-color: #ACE89C; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                                    </div>
                                                    <span style="font-size:11px;">>80% compliance</span>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div *ngIf="hasComplianceFiltered" class="product-module-titles">
                                            <p class="product-module-title-1">{{titleCompliance1 | number: "1.2-2"}}%</p>
                                            <p class="product-module-title-2">of Suppliers are low performers</p>
                                        </div> -->
                                        <div *ngIf="!hasComplianceFiltered" class="no-data w-full"> {{ "PRODUCT_MODULE.DPP_COMPONENT.NOTHING_TO_SEE" | translate }}</div>
                                    </div>
                                </div>
                                <div class="w-3/5  environmental-component-container">
                                    <div class="title-section">
                                        <h3 class="mt-2 mb-1 environmental-component-subtitle font-bold text-center">
                                            {{ "MONTHLY_IMPORTER.PERFORMANCE_DETAILS" | translate }}
                                        </h3>
                                        <mat-divider></mat-divider>
                                    </div>
                                    <div class="environmental-component-table">
                                        <loading-spinner *ngIf="isLoadingPerformanceDetails"></loading-spinner>
                                        <table *ngIf="!hasNotDataPerformanceDetails" mat-table [dataSource]="performanceDetailsDataList"
                                                #performanceDetailsMatSort="matSort" matSort>
                                            <ng-container matColumnDef="supplierName">
                                                <th mat-header-cell *matHeaderCellDef>
                                                <div class="flex flex-row items-end">
                                                   Supplier Name
                                                    <button  [matMenuTriggerFor]="floatingDivMenu"
                                                        mat-icon-button (click)="openColumnFilterMenu('supplier_name')" [matMenuTriggerData]="{ hasBackdrop: false }">
                                                        <mat-icon>filter_alt</mat-icon>
                                                    </button>
                                                </div>
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.supplier_name}}
                                                </td>
                                            </ng-container>>
                                            <ng-container matColumnDef="country">
                                                <th mat-header-cell *matHeaderCellDef>
                                                <div class="flex flex-row items-end">
                                                  Country
                                                    <button  [matMenuTriggerFor]="floatingDivMenu"
                                                        mat-icon-button (click)="openColumnFilterMenu('supplier_country')">
                                                        <mat-icon>filter_alt</mat-icon>
                                                    </button>
                                                </div>
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    {{element.supplier_country}}
                                                </td>
                                            </ng-container>
                                            <ng-container matColumnDef="chemicals">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <div class="flex flex-row items-end">
                                                  Chemicals
                                                    <button  [matMenuTriggerFor]="floatingDivMenu"
                                                        mat-icon-button (click)="openColumnFilterMenu('supplier_compliance')">
                                                        <mat-icon>filter_alt</mat-icon>
                                                    </button>
                                                </div>
                                                </th>
                                                <td 
                                                    mat-cell 
                                                    *matCellDef="let element" 
                                                    [ngClass]="{
                                                        'low-compliance': element.supplier_compliance > 0 && element.supplier_compliance < 60,
                                                        'medium-compliance': element.supplier_compliance >= 60 && element.supplier_compliance <= 80,
                                                        'high-compliance': element.supplier_compliance > 80
                                                    }">
                                                {{ element.supplier_compliance === 0 || element.supplier_compliance === null  ? 'N.A' : (element.supplier_compliance | number: '1.2-2') + '%' }}
                                                    </td>
                                            </ng-container>
                                            <ng-container matColumnDef="profile">
                                                <th mat-header-cell *matHeaderCellDef>Supplier Profile
                                                </th>
                                                <td mat-cell *matCellDef="let element">
                                                    <button (click)="viewProfile(element.supplier_name)" class="viewProfileButton">View Profile</button>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="performanceDetails; sticky: true;"></tr>
                                            <tr mat-row *matRowDef="let row; columns: performanceDetails;"></tr>
                                        </table>
                                         <!-- Global reusable filter menu -->
                                        <mat-menu #floatingDivMenu="matMenu" class="px-2 py-2 min-w-[200px]" class="filter-menu">
                                            <mat-form-field class="filterSelect w-full px-2 py-2" custom-margin-fix >
                                            <input matInput placeholder="Search..."
                                                    [(ngModel)]="filterText"
                                                    (ngModelChange)="updateFilteredColumnValues()"
                                                    (click)="$event.stopPropagation()"
                                                    (keydown)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-selection-list
                                            *ngIf="currentColumn === 'supplier_name'"
                                            [multiple]="true"
                                            [(ngModel)]="selectedValues"
                                            (selectionChange)="applyMultiColumnFilter()"
                                            (click)="$event.stopPropagation()"
                                            class="max-h-[250px] overflow-y-auto px-1">

                                            <mat-list-option *ngFor="let val of filteredColumnValues" [value]="val" (click)="$event.stopPropagation()" [disableRipple]="true">
                                                {{ val }}
                                            </mat-list-option>
                                            </mat-selection-list>

                                            <ng-container *ngIf="currentColumn !== 'supplier_name'">
                                                <div class="max-h-[250px] overflow-y-auto">
                                                    <button
                                                    mat-menu-item
                                                    *ngFor="let val of filteredColumnValues"
                                                    (click)="applyColumnFilter(val); $event.stopPropagation();">
                                                    {{ val }}
                                                    </button>
                                                </div>
                                            </ng-container>

                                            <div class="clear-container mt-2">
                                            <button mat-button color="primary" (click)="clearColumnFilter()">
                                                Clear Filter
                                            </button>
                                            </div>
                                        </mat-menu>
                                        <div *ngIf="hasNotDataPerformanceDetails" class="no-data w-full"> {{ "PRODUCT_MODULE.DPP_COMPONENT.NOTHING_TO_SEE" | translate }}</div>
                                    </div>
                                    <!-- <loading-spinner *ngIf="isLoadingTopChemicals"></loading-spinner> -->
                                    <mat-paginator *ngIf="!hasNotDataPerformanceDetails" #performanceDetailsMatPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" [pageSize]="5"
                                    showFirstLastButtons></mat-paginator>
                                </div>
                    </div>

                <div class="environmental-component-container" style="margin-top:10px;">
                    <div class="flex flex-row justify-end ">
                            <span class=" font-bold tracking-tight leading-8 flex-auto text-center">
                                {{ "MONTHLY_IMPORTER.DEVELOPMENT_OVER_TIME" | translate }}
                            </span>
                    </div>
                    <div class="mt-2 max-h-[450px] overflow-y-auto">
                         <loading-spinner *ngIf="isLoadingDevelopmentOverTime"></loading-spinner>
                        <div *ngIf="hasDevelopmentOverTime" style="height: 400px;">
                            <canvas baseChart height="280px" width="150px" [datasets]="developmentChartData"
                                [labels]="developmentChartLabelsProcess" [options]="chartOptions"
                                [legend]="chartLegend" type="bar" style="margin-left: 2vw; z-index: 1" #myChart>
                            </canvas>                            
                        </div>
                        <div class="product-module-legend-container">
                                <div>
                                    <div
                                       
                                        style="background-color: #EC8484; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                    </div>
                                    <span style="font-size:11px;">&lt;60% compliance</span>
                                </div>
                                <div>
                                    <div
                                       
                                        style="background-color: #FFD073; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                    </div>
                                    <span style="font-size:11px;">60-80% compliance</span>
                                </div>
                                <div>
                                    <div
                                        
                                        style="background-color: #ACE89C; width: 11px; height: 11px; display: inline-block; margin-right: 5px; font-size:11px;">
                                    </div>
                                    <span style="font-size:11px;">>80% compliance</span>
                                </div>
                            </div>
                        <div *ngIf="!hasDevelopmentOverTime" class="no-data w-full"> {{ "PRODUCT_MODULE.DPP_COMPONENT.NOTHING_TO_SEE" | translate }}</div>
                    </div>
                </div>
            </div>
        
        </div>

    </div>
 </div>